module.exports = __webpack_public_path__ + "img/logo_yilianyun@3x.9cfbcf4e.png";